import { OrderEditFormikDto } from '../OrderEditFormikDto';

export const orderGetMinDtoToEmptyFormik = (): OrderEditFormikDto => {
  const formik: OrderEditFormikDto = {
    customerId: '',
    palletId: '',
    containerId: '',
    shippingType: 'Sea',
    palletMaxWidth: '',
    palletMaxHeight: '',
    palletMaxLength: '',
    maxKg: '',
    dateOfTransaction: new Date(),
    dateOfTransport: new Date(),
    destination: '',
    containerLine: '',
    containerNo: '',
    vesselFlag: '',
    truckTrailer: '',
    routing: '',
    palletsDescription: '',
    totalWeightOfOrder: '',
    salesTerm: '',
    paymentTerm: '',
    cosigneeName: '',
    cosigneeAddress: '',
    warehouseOwnerId: '',
  };
  return formik;
};